import { queryOptions } from '@tanstack/react-query';

import { fetchProfile } from '../api/profile.api';

export const accountKeys = {
  all: ['account'] as const,
  profile: () => ['account', 'profile'] as const,
};

export const accountMutationKeys = {
  changePassword: () => [...accountKeys.all, 'mut', 'change-password'] as const,
  setPassword: () => [...accountKeys.all, 'mut', 'set-password'] as const,
  passwordCode: () => [...accountKeys.all, 'mut', 'password-code'] as const,
  passwordCodeVerify: () => [...accountKeys.all, 'mut', 'password-code-verify'] as const,
  language: () => [...accountKeys.all, 'mut', 'language'] as const,
  phoneCode: () => [...accountKeys.all, 'mut', 'phone-code'] as const,
  phoneVerify: () => [...accountKeys.all, 'mut', 'phone-verify'] as const,
  phoneEditCode: () => [...accountKeys.all, 'mut', 'phone-edit-code'] as const,
  phoneEditVerify: () => [...accountKeys.all, 'mut', 'phone-edit-verify'] as const,
  emailCode: () => [...accountKeys.all, 'mut', 'email-code'] as const,
  emailVerify: () => [...accountKeys.all, 'mut', 'email-verify'] as const,
};

export const ACCOUNT_STALE = 30 * 1000;
export const ACCOUNT_GC = 10 * 60 * 1000;

export const profileQueryOptions = () =>
  queryOptions({
    queryKey: accountKeys.profile(),
    queryFn: ({ signal }) => fetchProfile(signal),
    staleTime: ACCOUNT_STALE,
    gcTime: ACCOUNT_GC,
  });
